import axios from 'axios'

const downloadFile = (blobResponse, filename) => {
  const url = window.URL.createObjectURL(new Blob([blobResponse]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
}

const createUrl = (blobResponse) => {
  return window.URL.createObjectURL(new Blob([blobResponse], { type: 'application/pdf' }))
}

const cancelToken = axios.CancelToken
let cancelSource = cancelToken.source()

const refreshToken = () => {
  cancelSource = cancelToken.source()
}

const cancelAllRequests = () => {
  cancelSource.cancel('Operation canceled when leaving the page.')
}
export {
  cancelSource,
  downloadFile,
  createUrl,
  cancelAllRequests,
  refreshToken
}
